"use client";

import { useEffect } from "react";
import { initGlitchTipBrowserCapture } from "@/lib/glitchtip-browser";

export function GlitchTipBrowser() {
  useEffect(() => {
    initGlitchTipBrowserCapture();
  }, []);

  return null;
}
